const WhyBusinessesLove = () => {
  const features = [
    "Reduce manual attendance errors",
    "Improve employee transparency",
    "Simplify payroll operations",
    "Increase workforce productivity",
    "Easy mobile accessibility",
    "Faster leave approvals",
  ];

  return (
    <section className="w-full bg-[#FFFFFF] py-10 px-6">
      <div className="max-w-5xl mx-auto">
        {/* Heading */}
        <h2 className="text-center text-[#10324F] text-xl md:text-3xl font-bold uppercase tracking-wide mb-6">
          Why Businesses Love Waggex Staff App
        </h2>
        {/* Features Grid */}
        <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-12 place-items-start">
          {features.map((item, index) => (
            <div key={index} className="flex items-start gap-3 text-[#10324F]">
              {/* Diamond Icon */}
              <div className="shrink-0 w-5 h-5 mt-1 flex items-center justify-center">
                <div className="diamond-icon-sm"></div>
              </div>

              {/* Text */}
              <p className="text-sm md:text-base font-medium leading-relaxed">
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyBusinessesLove;
